import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/use-auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { LogIn, ArrowLeft } from "lucide-react";
import { siteConfig } from "../mock";

export default function LoginPage() {
  const [nif, setNif] = useState("");
  const [password, setPassword] = useState("");
  const { login, loading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/area-socio/dashboard";

  // Redirect if already logged in
  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, navigate, from]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const ok = await login(nif, password);
    if (ok) {
      navigate(from, { replace: true });
    }
  };

  return (
    <main className="pt-32 pb-20 bg-stone-50 min-h-screen">
      <div className="max-w-md mx-auto px-6">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-stone-500 hover:text-brand-700 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar ao site
        </Link>

        <div className="bg-white rounded-2xl shadow-xl border border-stone-100 p-8">
          <div className="text-center mb-8">
            <img
              src={siteConfig.logoBlue}
              alt="CATV"
              className="h-10 mx-auto mb-4"
            />
            <h1 className="text-2xl font-bold text-stone-900">
              Área do Sócio
            </h1>
            <p className="text-stone-500 text-sm mt-1">
              Inicia sessão com o teu NIF e password.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-sm font-medium text-stone-700 mb-1.5 block">
                NIF
              </label>
              <Input
                required
                type="text"
                inputMode="numeric"
                maxLength={9}
                value={nif}
                onChange={(e) => setNif(e.target.value)}
                placeholder="123456789"
              />
            </div>

            <div>
              <label className="text-sm font-medium text-stone-700 mb-1.5 block">
                Password
              </label>
              <Input
                required
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
              />
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-brand-700 hover:bg-brand-800 disabled:opacity-60 text-white rounded-full py-6 text-base font-semibold"
            >
              <LogIn className="w-4 h-4 mr-2" />
              {loading ? "A iniciar sessão..." : "Iniciar Sessão"}
            </Button>
          </form>

          <p className="text-center text-sm mt-4">
            <Link to="/area-socio/forgot-password" className="text-brand-700 hover:text-brand-800 font-semibold">
              Esqueceste a password?
            </Link>
          </p>

          <p className="text-center text-sm text-stone-500 mt-6">
            Ainda não tens conta?{" "}
            <Link
              to="/area-socio/registar"
              className="text-ember-500 hover:text-ember-600 font-semibold"
            >
              Cria a tua conta
            </Link>
          </p>
        </div>
      </div>
    </main>
  );
}
